export function needsConfirmation(needsConfirmationService) {
  'ngInject';

  return {
    link: link,
    restrict: 'AE',
    scope: {
      needsConfirmation: '&',
      confirmation: '&?',
      confirmTitle: '@?',
      confirmBody: '@?',
      confirmDismiss: '@?',
      confirmOk: '@?',
      skipConfirmation: '<'
    }
  };

  function link(scope, element) {
    // Skip confirmation
    if (scope.skipConfirmation) {
      return scope.confirmation ? scope.confirmation() : scope.needsConfirmation();
    }

    if (scope.needsConfirmation) {
      element.bind('click', (event) => {
        event.stopPropagation();
        event.preventDefault();

        needsConfirmationService.open({
          scope,
          onSuccess: scope.confirmation || scope.needsConfirmation
        });
      });
    }
  }
}
